<template>
  <div>
    <nav
      class="
        navbar navbar-vertical navbar-expand-md
        bg-transparent
        d-block d-sm-block d-md-none
      "
      id="sidenav-main"
    >
      <div class="container-fluid">
        <!--Toggler-->
        <navbar-toggle-button @click.native="showSidebar">
          <i class="ri-menu-fill table-text"></i>
        </navbar-toggle-button>
        <div class="input-group col-6">
          <input
            type="search"
            class="form-control border"
            v-model="search"
            :placeholder="$t('search')"
          />
        </div>

        <slot name="mobile-right">
          <ul class="nav align-items-center d-md-none">
            <base-dropdown class="nav-link pr-0">
              <div class="media align-items-center" slot="title">
                <div class="media-body mr-2">
                  <span class="mb-0 text-sm font-weight-bold"
                    ><img :src="flag.img" width="20" height="15"
                  /></span>
                </div>
              </div>

              <template>
                <a class="dropdown-item" @click="changeLang('en')">
                  <span
                    ><img src="/img/flags/en.png" width="15" height="15" />
                    {{ $t("english") }}</span
                  >
                </a>
                <a class="dropdown-item" @click="changeLang('es')">
                  <span
                    ><img src="/img/flags/es.jpg" width="15" height="15" />
                    {{ $t("spanish") }}</span
                  >
                </a>
                <a class="dropdown-item" @click="changeLang('de')">
                  <span
                    ><img src="/img/flags/de.png" width="15" height="15" />
                    {{ $t("germany") }}</span
                  >
                </a>
              </template>
            </base-dropdown>
            <div v-if="!user" class="mt-2">
              <b-button
                variant="primary"
                size="sm"
                @click="$router.push({ name: 'login' })"
              >
                <i class="fas fa-sign-in-alt"></i>
                {{ $t("login") }}
              </b-button>
              <b-button
                variant="secondary"
                size="sm"
                @click="$router.push({ name: 'register' })"
              >
                <i class="fas fa-user-plus"></i>
                {{ $t("sign_up") }}
              </b-button>
            </div>
            <base-dropdown v-else class="nav-item" position="right">
              <a slot="title" class="nav-link" href="#" role="button">
                <div class="media align-items-center">
                  <span class="avatar avatar-sm rounded-circle bg-primary">
                    {{ avatar }}
                  </span>
                </div>
              </a>

              <router-link to="/profile" class="dropdown-item">
                <i class="ni ni-single-02 table-text"></i>
                <span class="table-text">{{ $t("my_profile") }}</span>
              </router-link>
              <div @click="darkMode = !darkMode" class="dropdown-item">
                <i
                  class="table-text"
                  :class="darkMode ? 'ri-toggle-fill' : 'ri-toggle-line'"
                ></i>
                <span class="table-text">Modo Dark</span>
              </div>
              <div class="dropdown-divider"></div>
              <div @click="logout" class="dropdown-item">
                <i class="ni ni-user-run table-text"></i>
                <span class="table-text">{{ $t("logout") }}</span>
              </div>
            </base-dropdown>
          </ul>
        </slot>
        <slot></slot>
        <div
          v-show="$sidebar.showSidebar"
          class="navbar-collapse collapse show"
          id="sidenav-collapse-main"
        >
          <div class="navbar-collapse-header d-md-none">
            <div class="row">
              <div class="col-6 collapse-brand">
                <router-link to="/">
                  <img :src="logo" />
                </router-link>
              </div>
              <div class="col-6 collapse-close">
                <navbar-toggle-button
                  @click.native="closeSidebar"
                ></navbar-toggle-button>
              </div>
            </div>
          </div>

          <ul class="navbar-nav">
            <li class="nav-item">
              <router-link
                to="/"
                @click.native="linkClick"
                class="nav-link table-text"
                href="/"
              >
                <template>
                  <i class="ni ni-tv-2 text-primary"></i>
                  <span class="nav-link-text">Dashboard</span>
                </template>
              </router-link>
            </li>
            <li class="nav-item">
              <span
                class="nav-link table-text"
                @click="sendTo()"
                style="cursor: pointer"
              >
                <i class="fas fa-map-marker-alt text-info"></i>
                <span class="nav-link-text">
                  {{ $t("send_to") }} {{ model.city.label }}
                  <small>
                    <img
                      :src="isoCountry"
                      width="24"
                      height="17"
                      class="mr-1 mb-1"
                      style="border-radius: 1px"
                    />
                  </small>
                </span>
              </span>
            </li>
            <li class="nav-item">
              <span
                class="nav-link table-text"
                @click="connect"
                style="cursor: pointer"
              >
                <i class="fas fa-wallet text-warning"></i>
                <span
                  >{{ $t("wallet") }}
                  <i
                    class="far"
                    :class="status ? 'fa-check-square' : 'fa-window-close'"
                  ></i
                ></span>
              </span>
            </li>
            <li class="nav-item">
              <span
                class="nav-link table-text"
                @click="$router.push({ name: 'ecommerce_card' })"
                style="cursor: pointer"
              >
                <i class="fas fa-shopping-cart text-success"></i>
                <span>{{ "Articulos:" }} {{ leng ? leng : 0 }}</span>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <base-nav
      class="
        navbar navbar-horizontal navbar-expand-lg
        shadow
        d-none d-sm-none d-md-block
      "
      :fixed="fixedData"
      style="border-radius: 0px 0px 20px 20px"
    >
      <template v-slot:brand>
        <router-link to="/ecommerce">
          <img :src="logo" width="60" alt="logo" />
        </router-link>
      </template>

      <!-- sosdfksfkfdgkñfgdfgd -->
      <ul class="navbar-nav p-3 visible">
        <li class="nav-item">
          <div class="input-group mb-3">
            <input
              type="text"
              class="form-control border"
              v-model="search"
              :placeholder="$t('search')"
            />
          </div>
        </li>
        <li class="nav-item">
          <router-link
            to="/dashboard"
            @click.native="linkClick"
            class="nav-link table-text"
          >
            <template>
              <i class="ni ni-tv-2 text-primary"></i>
              <span class="nav-link-text"> Dashboard</span>
            </template>
          </router-link>
        </li>
        <li class="nav-item">
          <span
            class="nav-link table-text"
            @click="sendTo()"
            style="cursor: pointer"
          >
            <i class="fas fa-map-marker-alt text-info"></i>
            <span class="nav-link-text">
              {{ $t("send_to") }} {{ model.city.label }}
              <small>
                <img
                  :src="isoCountry"
                  width="24"
                  height="17"
                  class="mr-1 mb-1"
                  style="border-radius: 1px"
                />
              </small>
            </span>
          </span>
        </li>
        <li class="nav-item">
          <span
            class="nav-link table-text"
            @click="connect"
            style="cursor: pointer"
          >
            <i class="fas fa-wallet text-warning"></i>
            <span>
              {{ $t("wallet") }}
              <i
                class="far"
                :class="status ? 'fa-check-square' : 'fa-window-close'"
              ></i
            ></span>
          </span>
        </li>
        <li class="nav-item">
          <span
            class="nav-link table-text"
            @click="$router.push({ name: 'ecommerce_card' })"
            style="cursor: pointer"
          >
            <i class="fas fa-shopping-cart text-success"></i>
            <span> {{ "Articulos:" }} {{ leng ? leng : 0 }}</span>
          </span>
        </li>
        <li class="nav-item mt-2" v-if="!user">
          <b-button
            variant="primary"
            size="sm"
            @click="$router.push({ name: 'login' })"
          >
            <i class="fas fa-sign-in-alt"></i>
            {{ $t("login") }}
          </b-button>
          <b-button
            variant="secondary"
            size="sm"
            @click="$router.push({ name: 'register' })"
          >
            <i class="fas fa-sign-in-alt"></i>
            {{ $t("sign_up") }}
          </b-button>
        </li>
        <li class="nav-item mt-2" v-else>
          <ul class="navbar-nav align-items-center d-none d-md-flex">
            <li class="nav-item dropdown">
              <base-dropdown class="pr-0">
                <div class="media align-items-center" slot="title">
                  <span class="avatar avatar-sm rounded-circle bg-primary">
                    {{ avatar }}</span
                  >
                  <div class="media-body ml-2 d-none d-md-block">
                    <span
                      class="
                        mb-0
                        text-sm text-white
                        font-weight-bold
                        text-responsive
                        table-text
                      "
                      style="cursor: pointer"
                    >
                      {{ `${user.name} ${user.lastname}` }}
                    </span>
                  </div>
                </div>
                <template>
                  <router-link class="dropdown-item table-text" to="/dashboard">
                    <i class="fas fa-home"></i>
                    {{ $t("dashboard") }}
                  </router-link>
                  <router-link class="dropdown-item table-text" to="/profile">
                    <i class="ni ni-single-02" />
                    <span> {{ $t("my_profile") }} </span>
                  </router-link>
                  <div
                    class="dropdown-item table-text"
                    @click="darkMode = !darkMode"
                  >
                    <i
                      :class="darkMode ? 'ri-toggle-fill' : 'ri-toggle-line'"
                    />
                    <span> Modo Dark</span>
                  </div>
                  <div class="dropdown-divider"></div>
                  <div class="dropdown-item table-text" @click="logout">
                    <i class="ni ni-user-run" />
                    <span> {{ $t("logout") }}</span>
                  </div>
                </template>
              </base-dropdown>
            </li>
          </ul>
        </li>
      </ul>
      <!-- dskfsjdlfksjdfsdfsdf -->
      <ul class="navbar-nav none justify-content-around" style="width: 100%">
        <li class="nav-item ml-3" style="min-width: 140px">
          <b-button variant="secondary ml-3 p-1 rounded-lg" @click="sendTo()">
            <div>
              <i class="fas fa-map-marker-alt"></i>
              <small>
                {{ $t("send_to") }}
                <img
                  :src="isoCountry"
                  width="20"
                  height="14"
                  class="mr-1"
                  style="border-radius: 1px"
                />
              </small>
            </div>
            <div>
              <span>{{ model.city.label }}</span>
            </div>
          </b-button>
        </li>
        <li class="nav-item mt-2">
          <b-avatar
            class="ml-2 mr-2"
            rounded
            badge
            :badge-variant="status ? 'success' : 'bg-danger'"
            button
            @click="connect"
            :src="require('@/assets/img/brand/metamask.png')"
          >
          </b-avatar>
        </li>
        <li class="nav-item mt-1 w-50">
          <div class="input-group">
            <input
              type="text"
              class="form-control border border-right-0"
              v-model="search"
              :placeholder="$t('search')"
            />
            <span class="input-group-append">
              <button
                class="btn btn-outline-secondary border border-left-0"
                type="button"
              >
                <i class="fa fa-search"></i>
              </button>
            </span>
          </div>
        </li>
        <li class="nav-item mt-2" style="min-width: 110px">
          <base-dropdown>
            <div class="media align-items-center" slot="title">
              <div
                class="media-body ml-3 mb-0 text-sm table-text font-weight-bold"
                style="cursor: pointer"
              >
                <div class="d-inline">
                  <img :src="flag.img" width="20" height="13" class="mr-2" />
                </div>
                <div class="d-inline">
                  <span class="text-responsive">{{ flag.name }}</span>
                </div>
              </div>
            </div>
            <template>
              <a class="dropdown-item" @click="changeLang('en')">
                <span>
                  <img
                    :src="require('@/assets/img/flags/en.png')"
                    width="20"
                    height="13"
                    class="mr-1"
                  />
                  {{ $t("english") }}
                </span>
              </a>
              <a class="dropdown-item" @click="changeLang('es')">
                <span>
                  <img
                    src="/img/flags/es.jpg"
                    width="20"
                    height="13"
                    class="mr-1"
                  />
                  {{ $t("spanish") }}
                </span>
              </a>
              <a class="dropdown-item" @click="changeLang('de')">
                <span>
                  <img
                    src="/img/flags/de.png"
                    width="20"
                    height="13"
                    class="mr-1"
                  />
                  {{ $t("germany") }}
                </span>
              </a>
            </template>
          </base-dropdown>
        </li>
        <li class="nav-item mt-2" style="min-width: 50px">
          <span
            class="h3 table-text"
            style="cursor: pointer"
            @click="$router.push({ name: 'ecommerce_card' })"
          >
            <i class="fas fa-shopping-cart mr-2"></i>
            {{ leng }}
          </span>
        </li>
        <li class="nav-item mt-2" v-if="!user" style="min-width: 250px">
          <b-button
            variant="primary"
            size="sm"
            @click="$router.push({ name: 'login' })"
          >
            <i class="fas fa-sign-in-alt"></i>
            {{ $t("login") }}
          </b-button>
          <b-button
            variant="secondary"
            size="sm"
            @click="$router.push({ name: 'register' })"
          >
            <i class="fas fa-sign-in-alt"></i>
            {{ $t("sign_up") }}
          </b-button>
        </li>
        <li class="nav-item mt-2" v-else>
          <ul class="navbar-nav align-items-center d-none d-md-flex">
            <li class="nav-item dropdown">
              <base-dropdown class="pr-0">
                <div class="media align-items-center" slot="title">
                  <span class="avatar avatar-sm rounded-circle bg-primary">
                    {{ avatar }}</span
                  >
                  <div class="media-body ml-2 d-none d-md-block">
                    <span
                      class="
                        mb-0
                        text-sm
                        font-weight-bold
                        text-responsive
                        table-text
                      "
                      style="cursor: pointer"
                    >
                      {{ `${user.name} ${user.lastname}` }}
                    </span>
                  </div>
                </div>
                <template>
                  <router-link class="dropdown-item table-text" to="/dashboard">
                    <i class="fas fa-home"></i>
                    {{ $t("dashboard") }}
                  </router-link>
                  <router-link class="dropdown-item table-text" to="/profile">
                    <i class="ni ni-single-02" />
                    <span> {{ $t("my_profile") }} </span>
                  </router-link>
                  <div
                    class="dropdown-item table-text"
                    @click="darkMode = !darkMode"
                  >
                    <i
                      :class="darkMode ? 'ri-toggle-fill' : 'ri-toggle-line'"
                    />
                    <span> Modo Dark</span>
                  </div>
                  <div class="dropdown-divider"></div>
                  <div class="dropdown-item table-text" @click="logout">
                    <i class="ni ni-user-run" />
                    <span> {{ $t("logout") }}</span>
                  </div>
                </template>
              </base-dropdown>
            </li>
          </ul>
        </li>
      </ul>
    </base-nav>
    <b-modal id="bv-modal-send" centered no-close-on-backdrop>
      <template #modal-header>
        <h4>
          {{ $t("send_to") }}
        </h4>
        <b-button
          size="sm"
          variant="outline-light"
          class="ml-auto"
          @click="$bvModal.hide('bv-modal-send')"
        >
          <i class="fas fa-times"></i>
        </b-button>
      </template>
      <b-row>
        <b-col md="12">
          <base-input :label="$t('country')" required>
            <v-select
              class="form-control-alternative border bg-white p-2 rounded mt-2"
              v-model="model.country"
              :placeholder="$t('country')"
              autocomplete="ÑÖcompletes"
              :options="countriesOptions"
              data-vv-validate-on="blur"
              v-validate="'required'"
              :data-vv-as="$t('country')"
              @input="updateCities(model.country.value)"
              name="country"
            >
              <template #no-options="{}">
                {{ $t("fail") }}
              </template>
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('country')"
              ><small>{{ errors.first("country") }}</small></span
            >
          </base-input>
        </b-col>
        <b-col md="12">
          <base-input :label="$t('city')" required>
            <v-select
              class="form-control-alternative border bg-white p-2 rounded mt-2"
              v-model="model.city"
              autocomplete="ÑÖcompletes"
              :placeholder="$t('city')"
              :options="citiesOptions"
              name="city"
              data-vv-validate-on="blur"
              v-validate="'required'"
              :data-vv-as="$t('country')"
            >
              <template #no-options="{}">
                {{ $t("fail") }}
              </template>
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('city')"
              ><small>{{ errors.first("city") }}</small></span
            >
          </base-input>
        </b-col>
      </b-row>

      <template #modal-footer>
        <b-button size="sm" variant="primary" @click="countrySend()">
          {{ $t("save") }}
        </b-button>
        <b-button
          size="sm"
          variant="secondary"
          @click="$bvModal.hide('bv-modal-send')"
        >
          {{ $t("close") }}
        </b-button>
      </template></b-modal
    >
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import csrf from "@/services/csrf-cookie";
import _ from "lodash";
import { smartContract } from "@/directives/smart-contract";
import NavbarToggleButton from "@/components/NavbarToggleButton";
import BaseDropdown from "../BaseDropdown.vue";
import Web3 from "web3";
export default {
  mixins: [smartContract],
  async created() {
    await this.getCountries();
    this.debouncedGetAnswer = _.debounce(this.runFilter, 400);
  },
  components: {
    NavbarToggleButton,
    BaseDropdown,
  },
  beforeMount() {
    document.title = "M2M";
    const lang = localStorage.getItem("lang");
    localStorage.setItem("lang", lang !== null ? lang : "en");
    this.$i18n.locale = lang !== null ? lang : "en";
    // set 'app-background' class to body tag
    let bodyElement = document.body;
    bodyElement.classList.add("app-background");

    // check for active theme
    let htmlElement = document.documentElement;
    let theme = localStorage.getItem("theme");
    if (theme === "dark") {
      htmlElement.setAttribute("theme", "dark");
      this.darkMode = true;
    } else {
      htmlElement.setAttribute("theme", "light");
      this.darkMode = false;
    }

    let city = localStorage.getItem("Content-City");
    let country = localStorage.getItem("Content-Country");
    this.model.country = JSON.parse(country);
    this.model.city = JSON.parse(city);
  },
  mounted() {
    this.ChargeScroll();
  },
  watch: {
    search() {
      this.debouncedGetAnswer();
    },
    darkMode: function () {
      // add/remove class to/from html tag
      let htmlElement = document.documentElement;
      if (this.darkMode) {
        localStorage.setItem("theme", "dark");
        htmlElement.setAttribute("theme", "dark");
      } else {
        localStorage.setItem("theme", "light");
        htmlElement.setAttribute("theme", "light");
      }
    },
  },
  data() {
    return {
      fixedData: "",
      logo: require("@/assets/img/brand/favicon.png"),
      model: {
        country: "",
        city: "",
      },
      country_send: "",
      search: null,
      darkMode: false,
    };
  },
  inject: {
    autoClose: {
      default: true,
    },
  },
  methods: {
    closeSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    showSidebar() {
      this.$sidebar.displaySidebar(true);
    },
    linkClick() {
      if (
        this.autoClose &&
        this.$sidebar &&
        this.$sidebar.showSidebar === true
      ) {
        this.$sidebar.displaySidebar(false);
      }
    },

    ...mapActions({
      getCountries: "config/getCountry",
      getCities: "config/getCities",
      changeLanguage: "auth/updateLang",
      getProduct: "product/get",
    }),
    async runFilter() {
      await this.getProduct({
        search: this.search ? this.search : null,
      });
    },
    async changeLang(lang) {
      // const res = await this.changeLanguage({ lang: lang });
      this.$i18n.locale = lang;
      localStorage.setItem("lang", lang);
      this.$toast.success(this.$t("language_changed"), {
        position: "top-right",
      });
    },
    async logout() {
      try {
        await csrf.getCookie();
        const res = await this.$store.dispatch("auth/logout");
        this.$store.commit("auth/LOGOUT");
        this.$store.commit("auth/SET_USER", null);
        this.$store.commit("company/setCompanies", {
          data: [],
        });
        this.$toast.success(res.data.message, {
          position: "top-right",
        });
      } catch (error) {}
    },
    sendTo() {
      this.linkClick();
      this.$bvModal.show("bv-modal-send");
    },
    async updateCities(id) {
      this.model.city = "";
      await this.getCities(id);
    },
    darkThemeSwitch() {
      const res = localStorage.getItem("theme");
      if (res === "dark") {
        this.$store.commit("SET_THEME", "light");
        localStorage.setItem("theme", "light");
      } else {
        this.$store.commit("SET_THEME", "dark");
        localStorage.setItem("theme", "dark");
      }
      this.darkTheme = !this.darkTheme;
    },
    async countrySend() {
      const validation = await this.$validator.validateAll();
      if (validation) {
        localStorage.setItem(
          "Content-Country",
          JSON.stringify(this.model.country)
        );
        localStorage.setItem("Content-City", JSON.stringify(this.model.city));
        this.$toast.success(this.$t("change_country_send"), {
          position: "top-right",
        });
        this.$bvModal.hide("bv-modal-send");
      }
    },
    ChargeScroll() {
      window.onscroll = () => {
        if (document.documentElement.scrollTop >= 80) {
          this.fixedData = "top";
        } else {
          this.fixedData = "";
        }
      };
    },
  },
  computed: {
    ...mapGetters({
      user: "user",
      getShopping: "cart/shopping",
      countries: "config/countries",
      cities: "config/cities",
    }),
    leng() {
      if (this.getShopping) {
        return this.getShopping.products.length.toString() || 0;
      }
    },
    avatar() {
      if (this.user) {
        return `${this.user.name.charAt()}${this.user.lastname.charAt()}`;
      }
    },
    countriesOptions() {
      if (this.countries) {
        if (this.countries.data) {
          return this.countries.data.map(
            ({ id: value, name: label, iso: iso }) => ({
              value,
              label,
              iso,
            })
          );
        }
      }
      return [];
    },
    citiesOptions() {
      if (this.cities) {
        if (this.cities.data) {
          return this.cities.data.map(({ id: value, name: label }) => ({
            value,
            label,
          }));
        }
      }
      return [];
    },
    flag() {
      const locale = this.$i18n.locale;
      if (locale === "en")
        return { img: "/img/flags/en.png", name: this.$t("english") };
      else if (locale === "es")
        return { img: "/img/flags/es.jpg", name: this.$t("spanish") };
      else if (locale === "de")
        return { img: "img/flags/de.png", name: this.$t("germany") };
      else return { img: "/img/flags/en.png", name: this.$t("english") };
    },
    isoCountry() {
      if (this.model.country.iso) {
        let iso = this.model.country.iso.toLowerCase().trim();
        return `http://www.geonames.org/flags/x/${iso}.gif`;
      } else {
        return "";
      }
    },
  },
};
</script>
<style scoped>
.badge-danger {
  background-color: #f80031 !important;
}
.badge-success {
  background-color: #1aae6f !important;
}
@media screen and (max-width: 990px) {
  .none {
    display: none;
  }
}
@media screen and (min-width: 990px) {
  .visible {
    display: none;
  }
}
@media screen and (min-width: 770px) {
  .navbar {
    padding: 0px !important;
  }
  .navbar-horizontal .navbar-nav .nav-item .media:not(:last-child) {
    margin-bottom: 0px !important;
  }
}
@media screen and (max-width: 1250px) {
  .text-responsive {
    display: none;
  }
}
</style>